var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{
      icon: 'bx bx-time bx-tada', 
      title: 'manage.setting-monthly-billing-date', 
      link: 'manage-settting-property-monthly-biling',
    },"buttons":[{
      icon: 'bx bx-key', 
      title: 'manage.keyover.text', 
      link: 'manage-keyover'
    }],"title":_vm.$t('menuitems.property.text')}}),_c('Fastview',{ref:"fast-view",attrs:{"id":"fast-view","title":_vm.viewTitle,"item":_vm.viewObject,"filters":_vm.$options.filters}}),_c('List',{attrs:{"dataList":_vm.propertyData,"view":{link: 'manage-property-view'},"more":{
          sub: [
          {name: 'manage.room-status.rent-request', icon:'fa fa-paper-plane', link: 'manage-property-rent', column: 'id', show: {column: 'room_status_id', value: 1}},
          {name: 'manage.room-status.rent', icon:'bx bx-key', link: 'manage-property-rent-approve', column: 'id', show: {column: 'room_status_id', value: 2}},
          {name: 'manage.room-status.terminate-request', icon:'fa fa-hand-pointer', link: 'manage-property-rent-request-terminate', column: 'id', show: {column: 'room_status_id', value: 3}},
          {name: 'manage.room-status.terminated', icon:'fa fa-stop-circle', link: 'manage-property-rent-approve-terminate', column: 'id', show: {column: 'room_status_id', value: 4}},
          {name: 'manage.bill-invoice', icon:'fa fa-list', link: 'manage-invoice-generate', column: 'id'},
          {name: 'manage.payment', icon:'bx bx-dollar-circle', link: 'manage-property-invoice', column: 'id'},
          {
            name: 'manage.wattert-and-electrict-record', 
            icon:'bx bx-list-ul', 
            link: 'manage-property-utility', 
            column: 'id', 
            // show: 
            // {
            //   operation: '=',
            //   column: 'monthly_billing_date', 
            //   value: 12,
            // }
          },

          {name: 'Open Credit', icon:'bx bx-card', link: 'manage-open-credit', column: 'id'},
          {name: 'manage.rent.contract', icon:'bx bx-file', link: 'manage-property-rent-contract', column: 'id',  show: {column: 'room_status_id', value: 3}},
          {name: 'manage.rent.contract', icon:'bx bx-file', link: 'manage-property-rent-contract', column: 'id',  show: {column: 'room_status_id', value: 4}},
         
          {name: 'manage.service.setting', icon:'bx bx-cog', link: 'manage-setting-property-service-id', column: 'id'},
          {name: 'manage.keyover.contract', icon:'fas fa-check', link: 'manage-keyover-contract', column: 'id'} ]
        },"filter":{
          search: ['properties.code', 'properties.description'], 
          dropdown: [{
            title: 'property.project',
            field: 'properties.project_id',
            data: this.projectData.data,
            method: function (event) { return _vm.projectChanged(event); },
            default: 1,
            width: 2
          }, {
            title: 'property.status',
            field: 'properties.room_status_id',
            data: this.statusData.data
          }, {
            title: 'property.group',
            field: 'properties.property_group_id',
            data: this.groupData.data
          }, {
            title: 'property.floor',
            field: 'properties.project_floor_id',
            show: 'number',
            data: this.floorData.data
          }]
        },"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[
          {name: 'code', type: 'fast-view'}, 
          {name:'last_watter_record', type:'currency'}, 
          {name:'last_electrict_record', type:'currency'} ],"fields":[ 
          ("code: " + (_vm.$t('property.code'))), 
          ("project: " + (_vm.$t('property.project'))), 
          ("customer: " + ('ម្ចាស់បន្ទប់')), 
          ("tenant_name: " + ('អ្នកជួល')), 
          ("last_watter_record: " + (_vm.$t('manage.last-watter-record'))), 
          ("last_electrict_record: " + (_vm.$t('manage.last-electrict-record'))), 
          ("monthly_billing: " + (_vm.$t('manage.monthly-billing-date'))), 
          ("room_status_name: " + (_vm.$t('manage.room-status.text')))
          ]},on:{"more":_vm.moreClick,"view":_vm.clickFastView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }